var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"price-editor center-ag-grid-editor"},[_c('RInput',{ref:"input",attrs:{"value":_vm.formattedValue,"no-feedback-icon":"","no-hint":"","no-label":"","on-clear":"focus"},on:{"clear":_vm.clear}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }